import { render, staticRenderFns } from "./TagsManagerDialog.vue?vue&type=template&id=01629096&scoped=true&"
import script from "./TagsManagerDialog.vue?vue&type=script&lang=js&"
export * from "./TagsManagerDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerDialog.vue?vue&type=style&index=0&id=01629096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01629096",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VIcon,VSwitch})
